
import "../Css/custom-style.css";
import img1 from "../Images/areax..png";
import { Link } from "react-router-dom";

const Navbar = ({ apidata }) => {
  return (
    <>
      <section className="top-nav">
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
          <div className="container">
            <Link className="navbar-brand" to="/">
              {" "}
              
              <img src={apidata?.navbar?.logo} alt="Project W Logo" />
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link active zoom" aria-current="page" href="#footer">
                    {apidata?.navbar?.contactUs}
                  </a>
                </li>
              </ul>
              <form className="d-flex form-cus-nav" role="search">
                <ul className="nav-ul">
                  <li>
                    <a className="zoom" href="#subscribe">
                      {apidata?.navbar?.subscribe}
                    </a>
                  </li>
                </ul>
                <Link to="https://areax.ai">
                  {" "}
                  <img className="areax-img" src={img1} alt="Area X" />
                </Link>
              </form>
            </div>
          </div>
        </nav>
      </section>
    </>
  );
};

export default Navbar;
